import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    accategoriesChannel = new Subject();
    createChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchCategories = async (query) => {
        this.accategoriesChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCategories(query).then((result) => {
            this.accategoriesChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.accategoriesChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

}

export default CreateBloc